import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-char-counter-textarea',
  templateUrl: './char-counter-textarea.component.html',
  styleUrls: ['./char-counter-textarea.component.scss']
})
export class CharCounterTextareaComponent implements OnInit, OnChanges {
  textareaControl: FormControl = new FormControl();
  numberOfCharacters = 0;

  @Input() textValue: string;
  @Input() maxNumberOfCharacters: number;
  @Input() placeholderText?: string;
  @Input() isHighlighted = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();

  ngOnInit(): void {
    this.textareaControl.setValue(this.textValue || '');
    this.updateCharacterCount(this.textValue || '');

    this.textareaControl.valueChanges.subscribe((newValue) => {
      if (newValue.length > this.maxNumberOfCharacters) {
        newValue = newValue.slice(0, this.maxNumberOfCharacters);
        this.textareaControl.setValue(newValue, { emitEvent: false });
      }

      this.updateCharacterCount(newValue);
      this.valueChange.emit(newValue);
    });

    this.disabled ? this.textareaControl.disable() : this.textareaControl.enable();
  }

  ngOnChanges(changes): void {
    if (changes.textValue && !changes.textValue.isFirstChange()) {
      const newVal = changes.textValue.currentValue || '';
      this.textareaControl.setValue(newVal, { emitEvent: false });
      this.updateCharacterCount(newVal);
    }

    if (changes.disabled) {
      this.disabled ? this.textareaControl.disable() : this.textareaControl.enable();
    }
  }

  private updateCharacterCount(value: string): void {
    this.numberOfCharacters = value.length;
  }

  onInput(): void {
    const val = this.textareaControl.value;
    if (val.length > this.maxNumberOfCharacters) {
      this.textareaControl.setValue(val.slice(0, this.maxNumberOfCharacters));
    }
  }
}
